export default (value, payCycle) => (value * 12) / payCycle
